import { Divider, List } from "@mui/material";
import React, { ReactNode } from "react";
import { PageNavMenuItem } from "../PageNavMenuItem";

export interface IPageNavMenuItem {
    classes?: string;
    hidden?: boolean;
    id: string;
    title: string | ReactNode;
    subElement?: ReactNode;
    divider?: boolean;
}

export interface IPageNavMenuItemsProp {
    classes?: string;
    activeId: string;
    items: IPageNavMenuItem[];
    onToggleMenuItem: (id: string) => void;
}

export class PageNavMenuItems extends React.Component<IPageNavMenuItemsProp, {}> {
    render() {
        const props = this.props;
        return (
            <List sx={{ border: "1px solid", borderColor: "divider", borderRadius: ".5rem", padding: "0", overflow: "hidden" }}>
                {props.items.map((item) => {
                    const isDivider = !!item.divider;
                    if (!isDivider) {
                        return (
                            <PageNavMenuItem
                                key={item.id}
                                hidden={item.hidden}
                                isActive={props.activeId === item.id}
                                title={item.title}
                                onToggleMenuItem={props.onToggleMenuItem ? () => props.onToggleMenuItem(item.id) : null}
                                subElement={item.subElement}
                            />
                        );
                    }
                    return (
                        <Divider key={item.id}>{item.title}</Divider>
                    );
                })}
            </List>
        );
    }
}